import I18n from 'I18n';
import Raven from 'raven-js';
import * as React from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import { Text } from 'foundations-components/components/Text';
import UIResultsMessage from 'UIComponents/results/UIResultsMessage';
import ObjectTypeLabel from 'flow-doctor-lib/components/common/ObjectTypeLabel';
import ActionExecutionEnrollmentAnalysisDetails from 'flow-doctor-lib/components/diagnosis/details/ActionExecutionEnrollmentAnalysisDetails';
import BulkEnrollExistingAnalysisDetails from 'flow-doctor-lib/components/diagnosis/details/BulkEnrollExistingAnalysisDetails';
import BulkEnrollListAnalysisDetails from 'flow-doctor-lib/components/diagnosis/details/BulkEnrollListAnalysisDetails';
import BulkEnrollScheduledAnalysisDetails from 'flow-doctor-lib/components/diagnosis/details/BulkEnrollScheduledAnalysisDetails';
import BulkEnrollCustomFiltersAnalysisDetails from 'flow-doctor-lib/components/diagnosis/details/BulkEnrollCustomFiltersAnalysisDetails';
import ClassicReenrollmentAnalysisDetails from 'flow-doctor-lib/components/diagnosis/details/ClassicReenrollmentAnalysisDetails';
import DynamicEnrollAnalysisDetails from 'flow-doctor-lib/components/diagnosis/details/DynamicEnrollAnalysisDetails';
import EnrollmentInformationDetail from 'flow-doctor-lib/components/diagnosis/details/EnrollmentInformationDetail';
import EventBasedEnrollmentAnalysisDetails from 'flow-doctor-lib/components/diagnosis/details/EventBasedEnrollmentAnalysisDetails';
import EventEnrollListTriggerAnalysisDetails from 'flow-doctor-lib/components/diagnosis/details/EventEnrollListTriggerAnalysisDetails';
import ExternalTriggerEnrollAnalysisDetails from 'flow-doctor-lib/components/diagnosis/details/ExternalTriggerEnrollAnalysisDetails';
import ManualEnrollmentAnalysisDetails from 'flow-doctor-lib/components/diagnosis/details/ManualEnrollmentAnalysisDetails';
import PersistedReEnrollAnalysisDetails from 'flow-doctor-lib/components/diagnosis/details/PersistedReEnrollAnalysisDetails';
import UnknownEnrollmentAnalysisDetails from 'flow-doctor-lib/components/diagnosis/details/UnknownEnrollmentAnalysisDetails';
import EnrollmentAnalysisDebugBranchDescription from 'flow-doctor-lib/components/diagnosis/EnrollmentAnalysisDebugBranchDescription';
import FixedWidthEnrollmentFilterWithDetailsWrapper from 'flow-doctor-lib/components/diagnosis/FixedWidthEnrollmentFilterWithDetailsWrapper';
import ClassicReenrollmentTriggerSetsRenderer from 'flow-doctor-lib/components/filters/classicReenrollment/ClassicReenrollmentTriggerSetsRenderer';
import FlowEventFilterRenderer from 'flow-doctor-lib/components/filters/FlowEventFilterRenderer';
import WalmartEnrollmentFilterRenderer from 'flow-doctor-lib/components/filters/WalmartEnrollmentFilterRenderer';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollmentAnalysisDetails = ({
  diagnosisResult,
  selectedEnrollment
}) => {
  const isEnrollmentOlderThan6Months = selectedEnrollment.timestamp < I18n.moment().subtract(6, 'months').valueOf();
  React.useEffect(() => {
    if (isEnrollmentOlderThan6Months) {
      Raven.captureMessage('Enrollment diagnosis older than 6 months ago', {
        extra: {
          selectedEnrollment,
          diagnosisResult
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEnrollmentOlderThan6Months]);
  switch (diagnosisResult.reasonMetadata.reason) {
    case 'MANUAL_ENROLL':
      return /*#__PURE__*/_jsx(EnrollmentInformationDetail, {
        detail: /*#__PURE__*/_jsx(ManualEnrollmentAnalysisDetails, {
          selectedEnrollment: selectedEnrollment,
          diagnosisReason: diagnosisResult.reasonMetadata
        })
      });
    case 'BULK_ENROLL_EXISTING':
      return /*#__PURE__*/_jsx(EnrollmentInformationDetail, {
        detail: /*#__PURE__*/_jsx(BulkEnrollExistingAnalysisDetails, {
          selectedEnrollment: selectedEnrollment
        }),
        filterEvaluation: /*#__PURE__*/_jsx(EnrollmentAnalysisDebugBranchDescription, {
          selectedEnrollment: selectedEnrollment,
          filterBranch: diagnosisResult.reasonMetadata.filterBranch,
          debugFilterBranch: diagnosisResult.reasonMetadata.debugFilterBranch,
          filterWidthType: "WITH_FILTER_DETAILS"
        })
      });
    case 'BULK_ENROLL_LIST':
      return /*#__PURE__*/_jsx(EnrollmentInformationDetail, {
        detail: /*#__PURE__*/_jsx(BulkEnrollListAnalysisDetails, {
          diagnosisReason: diagnosisResult.reasonMetadata,
          selectedEnrollment: selectedEnrollment
        }),
        banner: /*#__PURE__*/_jsx(UIAlert, {
          type: "warning",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeDetail.BULK_ENROLL_LIST.banner"
          })
        })
      });
    case 'BULK_ENROLL_SCHEDULED':
      return /*#__PURE__*/_jsx(EnrollmentInformationDetail, {
        detail: /*#__PURE__*/_jsx(BulkEnrollScheduledAnalysisDetails, {
          diagnosisReason: diagnosisResult.reasonMetadata,
          selectedEnrollment: selectedEnrollment
        }),
        filterEvaluation: /*#__PURE__*/_jsx(EnrollmentAnalysisDebugBranchDescription, {
          selectedEnrollment: selectedEnrollment,
          filterBranch: diagnosisResult.reasonMetadata.filterBranch,
          debugFilterBranch: diagnosisResult.reasonMetadata.debugFilterBranch,
          filterWidthType: "WITH_FILTER_DETAILS"
        })
      });
    case 'BULK_ENROLL_FILTER':
      return /*#__PURE__*/_jsx(EnrollmentInformationDetail, {
        detail: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(UIAlert, {
            type: "warning",
            className: "m-bottom-4",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeDetail.BULK_ENROLL_FILTER.banner"
            })
          }), /*#__PURE__*/_jsx(BulkEnrollCustomFiltersAnalysisDetails, {
            diagnosisReason: diagnosisResult.reasonMetadata,
            selectedEnrollment: selectedEnrollment
          })]
        }),
        filterEvaluation: /*#__PURE__*/_jsx(EnrollmentAnalysisDebugBranchDescription, {
          selectedEnrollment: selectedEnrollment,
          filterBranch: diagnosisResult.reasonMetadata.filterBranch,
          debugFilterBranch: diagnosisResult.reasonMetadata.debugFilterBranch,
          filterWidthType: "WITH_FILTER_DETAILS"
        })
      });
    case 'EXTERNAL_TRIGGER_ENROLL':
      return /*#__PURE__*/_jsx(EnrollmentInformationDetail, {
        detail: /*#__PURE__*/_jsx(ExternalTriggerEnrollAnalysisDetails, {
          diagnosisReason: diagnosisResult.reasonMetadata,
          selectedEnrollment: selectedEnrollment
        })
      });
    case 'EVENT_ENROLL':
    case 'EVENT_RE_ENROLL':
      {
        return /*#__PURE__*/_jsx(EnrollmentInformationDetail, {
          detail: /*#__PURE__*/_jsx(EventBasedEnrollmentAnalysisDetails, {
            diagnosisReason: diagnosisResult.reasonMetadata,
            selectedEnrollment: selectedEnrollment
          }),
          filterEvaluation: /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(Text, {
              as: "h5",
              marginBlockEnd: "400",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeDetail.eventTrigger"
              })
            }), /*#__PURE__*/_jsx(FlowEventFilterRenderer, {
              portalId: selectedEnrollment.portalId,
              flowObjectTypeId: selectedEnrollment.objectTypeId,
              flowEventFilter: diagnosisResult.reasonMetadata.matchingEventFilter,
              debugFilter: diagnosisResult.reasonMetadata.flowEventFilterDebugFilterBranch,
              filterWidthType: "WITH_FILTER_DETAILS"
            })]
          }),
          refinementCriteria: diagnosisResult.reasonMetadata.reason === 'EVENT_ENROLL' && diagnosisResult.reasonMetadata.refinementFilterBranch && diagnosisResult.reasonMetadata.refinementDebugFilterBranch ? /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(Text, {
              as: "h5",
              marginBlockStart: "700",
              marginBlockEnd: "400",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeDetail.refinementCriteria"
              })
            }), /*#__PURE__*/_jsx(EnrollmentAnalysisDebugBranchDescription, {
              selectedEnrollment: selectedEnrollment,
              filterBranch: diagnosisResult.reasonMetadata.refinementFilterBranch,
              debugFilterBranch: diagnosisResult.reasonMetadata.refinementDebugFilterBranch,
              filterWidthType: "WITH_FILTER_DETAILS"
            })]
          }) : undefined
        });
      }
    case 'EVENT_ENROLL_LIST_TRIGGER':
      {
        return /*#__PURE__*/_jsx(EnrollmentInformationDetail, {
          detail: /*#__PURE__*/_jsx(EventEnrollListTriggerAnalysisDetails, {
            diagnosisReason: diagnosisResult.reasonMetadata,
            selectedEnrollment: selectedEnrollment
          })
        });
      }
    case 'ACTION_EXECUTION_ENROLL':
      return /*#__PURE__*/_jsx(EnrollmentInformationDetail, {
        banner: /*#__PURE__*/_jsx(UIAlert, {
          type: "warning",
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeDetail.ACTION_EXECUTION_ENROLL.banner_jsx",
            elements: {
              ObjectTypeLabel,
              b: 'b'
            },
            options: {
              objectTypeLabel: {
                objectTypeId: selectedEnrollment.objectTypeId,
                portalId: selectedEnrollment.portalId,
                plural: true
              }
            }
          })
        }),
        detail: /*#__PURE__*/_jsx(ActionExecutionEnrollmentAnalysisDetails, {
          selectedEnrollment: selectedEnrollment
        })
      });
    case 'CLASSIC_RE_ENROLL':
      return /*#__PURE__*/_jsx(EnrollmentInformationDetail, {
        detail: /*#__PURE__*/_jsx(ClassicReenrollmentAnalysisDetails, {
          diagnosisReason: diagnosisResult.reasonMetadata,
          selectedEnrollment: selectedEnrollment
        }),
        filterEvaluation: /*#__PURE__*/_jsx(FixedWidthEnrollmentFilterWithDetailsWrapper, {
          children: /*#__PURE__*/_jsx(ClassicReenrollmentTriggerSetsRenderer, {
            portalId: selectedEnrollment.portalId,
            objectTypeId: selectedEnrollment.objectTypeId,
            condensed: true,
            reEnrollmentTriggerSets: diagnosisResult.reasonMetadata.matchedTriggers
          })
        })
      });
    case 'PERSISTED_RE_ENROLL':
      return /*#__PURE__*/_jsx(EnrollmentInformationDetail, {
        detail: /*#__PURE__*/_jsx(PersistedReEnrollAnalysisDetails, {
          selectedEnrollment: selectedEnrollment,
          diagnosisReason: diagnosisResult.reasonMetadata
        }),
        filterEvaluation: /*#__PURE__*/_jsx(FixedWidthEnrollmentFilterWithDetailsWrapper, {
          children: /*#__PURE__*/_jsx(WalmartEnrollmentFilterRenderer, {
            objectTypeId: selectedEnrollment.objectTypeId,
            filterBranch: diagnosisResult.reasonMetadata.reEnrollmentList.filterBranch,
            filterWidthType: "WITH_FILTER_DETAILS"
          })
        })
      });
    case 'DYNAMIC_ENROLL':
      return /*#__PURE__*/_jsx(EnrollmentInformationDetail, {
        detail: /*#__PURE__*/_jsx(DynamicEnrollAnalysisDetails, {
          selectedEnrollment: selectedEnrollment,
          shouldDisplayEnrollmentWarning: diagnosisResult.reasonMetadata.debugFilterBranch.acceptedStatus === 'REJECTED'
        }),
        filterEvaluation: /*#__PURE__*/_jsx(EnrollmentAnalysisDebugBranchDescription, {
          selectedEnrollment: selectedEnrollment,
          filterBranch: diagnosisResult.reasonMetadata.filterBranch,
          debugFilterBranch: diagnosisResult.reasonMetadata.debugFilterBranch,
          filterWidthType: "WITH_FILTER_DETAILS"
        })
      });
    case 'UNKNOWN':
    default:
      return /*#__PURE__*/_jsx(EnrollmentInformationDetail, {
        detail: /*#__PURE__*/_jsx(UnknownEnrollmentAnalysisDetails, {
          selectedEnrollment: selectedEnrollment
        }),
        banner: isEnrollmentOlderThan6Months ? /*#__PURE__*/_jsx(UIAlert, {
          titleText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeDescription.default.oldEnrollment.title"
          }),
          type: "warning",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeDescription.default.oldEnrollment.description"
          })
        }) : null,
        filterEvaluation: /*#__PURE__*/_jsx(UIResultsMessage, {
          illustration: "empty-state-charts",
          illustrationProps: {
            width: 220
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: getIsInternal() ? 'flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeDescription.default.contextInternal' : 'flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeDescription.default.contextExternal'
          })
        })
      });
  }
};
export default EnrollmentAnalysisDetails;